/* eslint-disable react-hooks/exhaustive-deps */
import { React, useEffect, useState, useCallback } from 'react'
import {
	Drawer,
	Button,
	Center,
	Text,
	Input,
	Checkbox,
	useDisclosure,
	DrawerOverlay,
	DrawerContent,
	DrawerCloseButton,
	DrawerHeader,
	DrawerBody,
	DrawerFooter,
} from '@chakra-ui/react'

import {
	useInviteParticipant,
	useSearchOrgContacts,
	useExternalGuestsAdd,
} from '../../../hooks/activity.hooks'
import { useLanguageContext } from '../../../context/locale.context'
import {
	sectionDetailedTrack,
	GA_CATEGORY_DIALOG_BOX,
	dataLayerTagManager,
	eventLabelTrack,
} from '../../repository/repo.utils'

function Inviteparticipants({ activity, isOpenactive, setIsOpenactive }) {
	const [data, setdata] = useState([])
	const { activity_id, activity_type_id, activity_type_category_id } = activity
	const { mutate: inviteMutate } = useInviteParticipant()
	const { mutate: searchContactMutate } = useSearchOrgContacts()
	const { mutate: externalGuestsAddMutate } = useExternalGuestsAdd()

	const [name, setName] = useState('')
	const [email, setEmail] = useState('')
	const [designation, setDesignation] = useState('')
	const [send_email, setSendMail] = useState(0)
	const [error, setError] = useState('')

	const handleInput = n => e => {
		if (n === 'name') {
			setName(e.target.value)
		} else if (n === 'designation') {
			setDesignation(e.target.value)
		} else if (n === 'email') {
			setEmail(e.target.value)
		} else if (n === 'sendmail') {
			setSendMail(!!e.target.checked ? 1 : 0)
		}
		setError('')
	}

	const {
		state: { locale },
	} = useLanguageContext()

	const addEmail = () => {
		const createRegExp = (str, opts) =>
			new RegExp(str.raw[0].replace(/\s/gm, ''), opts || '')
		const email_regex = createRegExp`
      ^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|
      (\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|
      (([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$`
		if (!name || !designation || !email) {
			setError('Enter all fields')
		} else {
			if (email.match(email_regex)) {
				addExternalGuests({
					emails: [{ email, designation, name }],
					workflow_activity_id: activity.activity_id,
					activity_type_id: activity.activity_type_id,
					send_email: send_email,
				})
			} else {
				setError('Enter valid email')
			}
		}
	}

	const addExternalGuests = useCallback(params => {
		externalGuestsAddMutate(
			{ ...params },
			{
				onSuccess: async data => {
					setEmail('')
					setName('')
					setDesignation('')
					setError('')
					setIsOpenactive(false)
				},
				onError: async data => {},
			}
		)
	})

	const inviteUser = useCallback(
		({
			contact_asset_type_id,
			contact_asset_id,
			contact_first_name,
			contact_operating_asset_name,
			workforce_name,
		}) => {
			inviteMutate(
				{
					activity_id,
					activity_type_category_id: activity_type_category_id,
					activity_type_id,
					contact: {
						asset_type_id: contact_asset_type_id,
						asset_id: contact_asset_id,
						asset_first_name: contact_first_name,
						operating_asset_first_name: contact_operating_asset_name,
						workforce_name,
					},
				},
				{
					onSuccess: async data => {},
				}
			)
		}
	)

	// const loadContacts = useCallback(search_string => {
	// 	searchContactMutate(
	// 		{ search_string },
	// 		{
	// 			onSuccess: async data => {
	// 				setdata(data)
	// 			},
	// 		}
	// 	)
	// })

	// useEffect(() => {
	// 	loadContacts('s')
	// }, [])
	const { isOpen, onOpen, onClose } = useDisclosure()
	const onCloseDrawer = () => {
		setIsOpenactive(false)
	}
	return (
		<Drawer isOpen={true} placement='right' onClose={onClose}>
			<DrawerOverlay />
			<DrawerContent bg={'#F2F3F8'}>
				<DrawerCloseButton color={'red.600'} onClick={onCloseDrawer} />
				<DrawerHeader
					fontSize={'16px'}
					fontWeight='500'
					color={'#000000'}
					fontStyle='normal'
					borderBottom={'1px solid #BBBBBB'}
				>
					{locale['Invite']}
				</DrawerHeader>

				<DrawerBody>
					<Input
						placeholder={locale['Name']}
						color={'#000000'}
						border={'none'}
						autoFocus={true}
						borderRadius='none'
						borderBottom='1px solid rgba(0, 0, 0, 0.25)'
						required
						value={name}
						onChange={handleInput('name')}
						_focus={{
							boxShadow: 'none',
						}}
						_hover={{
							boxShadow: 'none',
						}}
						_placeholder={{ color: '#979797' }}
						fontSize='14px'
					/>
					<Input
						placeholder={locale['Designation']}
						border={'none'}
						borderRadius='none'
						borderBottom='1px solid rgba(0, 0, 0, 0.25)'
						value={designation}
						onChange={handleInput('designation')}
						_focus={{
							boxShadow: 'none',
						}}
						_hover={{
							boxShadow: 'none',
						}}
						_placeholder={{ color: '#979797' }}
						fontSize='14px'
					/>
					<Input
						placeholder={locale['Email']}
						border={'none'}
						borderRadius='none'
						borderBottom='1px solid rgba(0, 0, 0, 0.25)'
						onChange={handleInput('email')}
						value={email}
						_focus={{
							boxShadow: 'none',
						}}
						_hover={{
							boxShadow: 'none',
						}}
						_placeholder={{ color: '#979797' }}
						fontSize='14px'
					/>
					<Checkbox
						mt='1rem'
						onChange={() => handleInput('sendmail')}
						fontSize='14px'
						_focus={{
							boxShadow: 'none',
						}}
						_hover={{
							boxShadow: 'none',
						}}
						color='#000000'
						colorScheme='green'
					>
						{locale['Send invite mail']}
					</Checkbox>
					<Text my={2} color='red'>
						{error}
					</Text>
				</DrawerBody>

				<DrawerFooter
					bg='#FFFFFF'
					boxShadow={'0px 0px 28px -6px rgba(24, 39, 75, 0.12)'}
				>
					<Center>
						<Button
							size='sm'
							borderRadius='17px'
							bg='linear-gradient(266.6deg, #009B76 2.89%, #008363 93.97%)'
							w='100px'
							boxShadow={'1px 1px 1px rgba(0, 0, 0, 0.1)'}
							color='#FFFFFF'
							fontSize={'14px'}
							fontWeight='500'
							mr='5rem'
							onClick={() => {
								sectionDetailedTrack({
									category: GA_CATEGORY_DIALOG_BOX,
									action: 'Active Participant',
									label: 'Invite',
								})
								dataLayerTagManager('button_click', {
									viewName: 'Add Participant',
									buttonName: 'External Invite',
								})
								addEmail()
							}}
						>
							{/* {inviteDelegate ? ['Delegate'] : locale['Invite']} */}
							{locale['Invite']}
						</Button>
					</Center>
				</DrawerFooter>
			</DrawerContent>
		</Drawer>
	)
}

export default Inviteparticipants
